import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { resetPassword } from "../../redux/reducer/authReducer";
import CustomTitleWihBox from "../sharedComponents/customTitleWithBox";
import { useTranslation } from "react-i18next";
import { LockOpenIcon } from "@heroicons/react/24/outline";
import CustomPasswordInput from "../accountUser/customPasswordInput";
import useLanguageDirection from "../../hooks/useLanguageDirection";
import { useLanguageNavigate } from "../../hooks/useLanguageNavigation";

export default function ResetPasswordForm() {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [token, setToken] = useState("");
  const dispatch = useDispatch();
  const { loading, message, error } = useSelector((state) => state.auth);
  const { t } = useTranslation();
  const direction = useLanguageDirection();
  const navigateWithLang = useLanguageNavigate();
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      alert(t("PasswordsDoNotMatch"));
      return;
    }

    try {
      const resultAction = await dispatch(resetPassword({ token, password }));

      if (resetPassword.fulfilled.match(resultAction)) {
        if (resetPassword.fulfilled.match(resultAction)) {
          // alert(t("Password_reset_successfully"));
          setTimeout(() => {
            navigateWithLang("/login");
          }, 2000);
        }
      } else {
        // alert(resultAction.payload?.message || t("FailedToResetPassword"));
      }
    } catch (error) {
      console.error("Error resetting password:", error);
    }
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const tokenFromURL = params.get("token");
    if (tokenFromURL) {
      setToken(tokenFromURL);
    }
  }, []);
  // console.log(token)
  // console.log(message);
  return (
    <div
      className="block  p-8 mx-auto bg-white rounded-lg shadow-lg md:w-2/3 max-w-[700px]"
      dir={direction}
    >
      <CustomTitleWihBox title={t("ResetPasswordTitle")} />
      <form onSubmit={handleSubmit} className="">
        <div className="mb-4">
          <CustomPasswordInput
            id="password"
            placeholder={t("NewPassword")}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            icon={<LockOpenIcon />}
            required
          />
        </div>
        <div className="mb-4">
          <CustomPasswordInput
            id="confirmPassword"
            placeholder={t("ConfirmPassword")}
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            icon={<LockOpenIcon />}
            required
          />
        </div>
        <button
          type="submit"
          className="block w-full px-6 py-2 font-medium text-black uppercase transition duration-150 ease-in-out rounded-lg shadow-lg lg:text-lg lg:py-3 bg-custom-yellow hover:bg-primary-600 focus:outline-none"
          disabled={loading}
        >
          {loading ? "Resetting..." : t("ResetPasswordTitle")}
        </button>
      </form>
      {message && <p className="mt-4 text-green-600">{t(`${message}`)}</p>}
      {error && <p className="mt-4 text-red-600">{t(`${error}`)}</p>}
    </div>
  );
}
